












































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import axios from 'axios';
import UserModule from '@/store/modules/user';
import { enumToObject } from '@/utils/util';
import { Dialog, Notify } from 'vant';

@Component
export default class AddQuestion extends Vue {
  isLoading: boolean = false;

  detail: any = '';

  classificationShow: boolean = false;

  importanceShow: boolean = false;

  columns: any = [];

  attachments: any = [];

  importanceColumns = [
    {
      values: [
        models.ProblemImportance[models.ProblemImportance.非常重要],
        models.ProblemImportance[models.ProblemImportance.重要],
        models.ProblemImportance[models.ProblemImportance.一般],
      ],
      defaultIndex: 0,
    },
  ];

  importanceValue: string = '';

  form: models.ProblemDto = {
    className: null,
    classType: 0,
    publicTrainingClassId: null,
    title: null,
    category: null,
    importance: 0,
    content: null,
    id: null,
  };

  isDisabled: boolean = false;

  get ProblemImportance() {
    return models.ProblemImportance;
  }

  delProblem(id: string) {
    Dialog.confirm({
      title: '提示 ',
      message: '您确定要删除此条记录吗',
    })
      .then(async () => {
        const { data, success, message } = await api.Problem.deleteByIds_POST({
          ids: [this.form.id],
        });
        if (success) {
          this.$router.go(-1);
          Notify({ type: 'primary', message: '删除成功' });
        } else {
          Notify({ type: 'danger', message: '删除失败' });
        }
      })
      .catch(() => {});
  }

  markingIssues(val: boolean) {
    const text = val ? '确定标记问题为已解决吗？' : '确定标记问题为未解决吗？';
    Dialog.confirm({
      title: '提示 ',
      message: text,
    })
      .then(async () => {
        const { data, success, message } = await api.Problem.setSolvedState_POST({
          id: this.form.id,
          isSolved: val,
        });
        if (success) {
          this.detail.isSolved = !this.detail.isSolved;
          Notify({ type: 'primary', message: '操作成功' });
        } else {
          Notify({ type: 'danger', message: '操作失败' });
        }
      })
      .catch(() => {});
  }

  async getAttachment(keyName: string, key: string) {
    const { data } = await apiAxios.get('/api/NewAttachment/GetAttachmens', {
      params: {
        StringKey1: key,
        Category: keyName,
      },
    });
    this.attachments = data;
  }

  onClickLeft() {
    this.$router.go(-1);
  }

  onConfirm(val) {
    this.form.category = val;
    this.classificationShow = false;
  }

  onImportanceConfirm(value) {
    this.importanceValue = value;
    this.form.importance = enumToObject(models.ProblemImportance).find(e => e.label == value).value;
    this.importanceShow = false;
  }

  onCancel() {
    this.classificationShow = false;
  }

  onImportanceCancel() {
    this.importanceShow = false;
  }

  async getClassification() {
    try {
      await apiAxios
        .get('/api/Standard/GetItemFromCode?code=ProblemCategory', axiosOptions)
        .then(res => {
          if (res) {
            this.columns = res.data.data.map(item => item.name);
          }
        })
        .catch(err => {});
    } catch (err) {
      console.log('%c [ err ]-373', 'font-size:13px; background:pink; color:#bf2c9f;', err);
    }
  }

  async onSubmit() {
    try {
      const { data, success, message } = await api.Problem.save_POST(this.form);
      if (success) {
        Object.keys(this.form).forEach((k: any) => {
          if (k == 'importance' || k == 'classType') this.form[k] = 0;
          else this.form[k] = null;
        });
        Dialog.alert({
          message: '提交成功',
        }).then(() => {
          this.$router.go(-1);
        });
      } else {
        Dialog.alert({
          message: '添加失败',
        });
      }
    } finally {
      this.isLoading = false;
    }
  }

  mounted() {
    if (this.$route.query.type === 'edit') this.isDisabled = false;
    if (this.$route.query.type === 'readonly') this.isDisabled = true;
    if (this.$route.query.info) {
      this.detail = JSON.parse(this.$route.query.info as any);
      Object.keys(this.form).forEach(k => {
        if (k in this.detail) this.form[k] = this.detail[k];
      });
      this.importanceValue = this.ProblemImportance[this.form.importance];
    }

    if (this.$route.query.classInfo) {
      const classInfo = JSON.parse(this.$route.query.classInfo as any);
      this.detail = JSON.parse(this.$route.query.classInfo as any);
      this.form.className = classInfo.className;
      this.form.classType = classInfo.classType;
      this.form.publicTrainingClassId = classInfo.id;
    }

    if (this.detail.responseAttachmentKey) this.getAttachment('问题回复附件', this.detail.responseAttachmentKey);
    this.getClassification();
  }
}

export interface AxiosRequestConfig {
  baseURL?: string;
  headers: object;
}
const axiosOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_ROOT,
  headers: {
    Authorization: `${'Bearer ' + UserModule.getToken}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
const apiAxios = axios.create(axiosOptions);
